import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Port } from "@/types/port";

// For filters dropdowns
export const usePortsForFilters = (filters: { cityId?: string; countryId?: string } = {}) => {
  const { cityId, countryId } = filters;
  
  const queryKey = ['ports-filter', { cityId, countryId }];

  const queryFn = async () => {
    let query = supabase.from('ports').select('id, name_ar, port_code');
    if (cityId && cityId !== 'all') {
      query = query.eq('city_id', cityId);
    } else if (countryId && countryId !== 'all') {
      query = query.eq('country_id', countryId);
    }
    
    const { data, error } = await query;
    if (error) throw error;
    return data;
  };

  return useQuery({
      queryKey,
      queryFn,
      enabled: (!!cityId && cityId !== 'all') || (!!countryId && countryId !== 'all')
  });
};

// For the main Ports page table/cards
export const useFetchPorts = () => {
    return useQuery({
      queryKey: ['ports'],
      queryFn: async () => {
        const { data, error } = await supabase
          .from('ports')
          .select(`
            *,
            cities(name_ar),
            countries(name_ar)
          `)
          .order('created_at', { ascending: false });
        
        if (error) throw error;
        return data as (Omit<Port, 'cities' | 'countries'> & { cities: { name_ar: string } | null; countries: { name_ar: string } | null; })[];
      },
    });
};